/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { UserProfileModel } from '../models/user-profile-model';
import { UploadToken } from '../models/upload-token';
import { User } from '../models/user';
import { PageUsers } from '../models/page-users';
@Injectable({
  providedIn: 'root',
})
class UserService extends __BaseService {
  static readonly UserRegisterUserPath = '/api/User/RegisterUser';
  static readonly UserGetUploadTokenPath = '/api/User/GetUploadToken';
  static readonly UserResetUserCachePath = '/api/User/ResetUserCache/{customerId}/{userId}';
  static readonly UserGetProfilePath = '/api/User/GetUserProfile';
  static readonly UserLinkProductToUserPath = '/api/User/LinkProductToUser';
  static readonly UserUnlinkProductToUserPath = '/api/User/UnlinkProductToUser';
  static readonly UserCreateNewUserPath = '/api/User/CreateNewUser';
  static readonly UserGetAllUsersPath = '/api/User/GetAllUsers';
  static readonly UserGetUserByIdPath = '/api/User/GetUserById';
  static readonly UserDeleteUserByIdPath = '/api/User/DeleteUserById';
  static readonly UserUpdateUserPath = '/api/User/UpdateUser';
  static readonly UserOnboardUserPath = '/api/User/OnboardUser';
  static readonly UserAcknowledgeReleaseNotesPath = '/api/User/AcknowledgeReleaseNotes';
  static readonly UserSearchByNamePath = '/api/User/SearchByName';
  static readonly UserLogActivityPath = '/api/User/LogActivity';
  static readonly UserWhosOnMyPagePath = '/api/User/WhosOnMyPage';
  static readonly UserWhosActivePath = '/api/User/WhosActive';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }
  UserRegisterUserResponse(): __Observable<__StrictHttpResponse<UserProfileModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/User/RegisterUser`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UserProfileModel>;
      })
    );
  }  UserRegisterUser(): __Observable<UserProfileModel> {
    return this.UserRegisterUserResponse().pipe(
      __map(_r => _r.body as UserProfileModel)
    );
  }
  UserGetUploadTokenResponse(): __Observable<__StrictHttpResponse<UploadToken>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/User/GetUploadToken`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UploadToken>;
      })
    );
  }  UserGetUploadToken(): __Observable<UploadToken> {
    return this.UserGetUploadTokenResponse().pipe(
      __map(_r => _r.body as UploadToken)
    );
  }

  /**
   * @param params The `UserService.UserResetUserCacheParams` containing the following parameters:
   *
   * - `userId`:
   *
   * - `customerId`:
   */
  UserResetUserCacheResponse(params: UserService.UserResetUserCacheParams): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;


    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/User/ResetUserCache/${encodeURIComponent(String(params.customerId))}/${encodeURIComponent(String(params.userId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param params The `UserService.UserResetUserCacheParams` containing the following parameters:
   *
   * - `userId`:
   *
   * - `customerId`:
   */
  UserResetUserCache(params: UserService.UserResetUserCacheParams): __Observable<Blob> {
    return this.UserResetUserCacheResponse(params).pipe(
      __map(_r => _r.body as Blob)
    );
  }
  UserGetProfileResponse(): __Observable<__StrictHttpResponse<UserProfileModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/User/GetUserProfile`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UserProfileModel>;
      })
    );
  }  UserGetProfile(): __Observable<UserProfileModel> {
    return this.UserGetProfileResponse().pipe(
      __map(_r => _r.body as UserProfileModel)
    );
  }

  /**
   * @param params The `UserService.UserLinkProductToUserParams` containing the following parameters:
   *
   * - `userId`:
   *
   * - `productId`:
   *
   * - `description`:
   */
  UserLinkProductToUserResponse(params: UserService.UserLinkProductToUserParams): __Observable<__StrictHttpResponse<User>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.userId != null) __params = __params.set('userId', params.userId.toString());
    if (params.productId != null) __params = __params.set('productId', params.productId.toString());
    if (params.description != null) __params = __params.set('description', params.description.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/User/LinkProductToUser`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<User>;
      })
    );
  }
  /**
   * @param params The `UserService.UserLinkProductToUserParams` containing the following parameters:
   *
   * - `userId`:
   *
   * - `productId`:
   *
   * - `description`:
   */
  UserLinkProductToUser(params: UserService.UserLinkProductToUserParams): __Observable<User> {
    return this.UserLinkProductToUserResponse(params).pipe(
      __map(_r => _r.body as User)
    );
  }

  /**
   * @param params The `UserService.UserUnlinkProductToUserParams` containing the following parameters:
   *
   * - `userId`:
   *
   * - `productId`:
   */
  UserUnlinkProductToUserResponse(params: UserService.UserUnlinkProductToUserParams): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.userId != null) __params = __params.set('userId', params.userId.toString());
    if (params.productId != null) __params = __params.set('productId', params.productId.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/User/UnlinkProductToUser`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param params The `UserService.UserUnlinkProductToUserParams` containing the following parameters:
   *
   * - `userId`:
   *
   * - `productId`:
   */
  UserUnlinkProductToUser(params: UserService.UserUnlinkProductToUserParams): __Observable<Blob> {
    return this.UserUnlinkProductToUserResponse(params).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param model undefined
   */
  UserCreateNewUserResponse(model: User): __Observable<__StrictHttpResponse<User>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = model;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/User/CreateNewUser`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<User>;
      })
    );
  }
  /**
   * @param model undefined
   */
  UserCreateNewUser(model: User): __Observable<User> {
    return this.UserCreateNewUserResponse(model).pipe(
      __map(_r => _r.body as User)
    );
  }
  UserGetAllUsersResponse(): __Observable<__StrictHttpResponse<Array<User>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/User/GetAllUsers`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<User>>;
      })
    );
  }  UserGetAllUsers(): __Observable<Array<User>> {
    return this.UserGetAllUsersResponse().pipe(
      __map(_r => _r.body as Array<User>)
    );
  }

  /**
   * @param userId undefined
   */
  UserGetUserByIdResponse(userId?: number): __Observable<__StrictHttpResponse<User>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (userId != null) __params = __params.set('userId', userId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/User/GetUserById`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<User>;
      })
    );
  }
  /**
   * @param userId undefined
   */
  UserGetUserById(userId?: number): __Observable<User> {
    return this.UserGetUserByIdResponse(userId).pipe(
      __map(_r => _r.body as User)
    );
  }

  /**
   * @param userId undefined
   */
  UserDeleteUserByIdResponse(userId?: number): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (userId != null) __params = __params.set('userId', userId.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/User/DeleteUserById`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param userId undefined
   */
  UserDeleteUserById(userId?: number): __Observable<Blob> {
    return this.UserDeleteUserByIdResponse(userId).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param model undefined
   */
  UserUpdateUserResponse(model: User): __Observable<__StrictHttpResponse<User>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = model;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/User/UpdateUser`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<User>;
      })
    );
  }
  /**
   * @param model undefined
   */
  UserUpdateUser(model: User): __Observable<User> {
    return this.UserUpdateUserResponse(model).pipe(
      __map(_r => _r.body as User)
    );
  }

  /**
   * @param model undefined
   */
  UserOnboardUserResponse(model: UserProfileModel): __Observable<__StrictHttpResponse<UserProfileModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = model;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/User/OnboardUser`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UserProfileModel>;
      })
    );
  }
  /**
   * @param model undefined
   */
  UserOnboardUser(model: UserProfileModel): __Observable<UserProfileModel> {
    return this.UserOnboardUserResponse(model).pipe(
      __map(_r => _r.body as UserProfileModel)
    );
  }
  UserAcknowledgeReleaseNotesResponse(): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/User/AcknowledgeReleaseNotes`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }  UserAcknowledgeReleaseNotes(): __Observable<Blob> {
    return this.UserAcknowledgeReleaseNotesResponse().pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param name undefined
   */
  UserSearchByNameResponse(name?: null | string): __Observable<__StrictHttpResponse<Array<User>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (name != null) __params = __params.set('name', name.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/User/SearchByName`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<User>>;
      })
    );
  }
  /**
   * @param name undefined
   */
  UserSearchByName(name?: null | string): __Observable<Array<User>> {
    return this.UserSearchByNameResponse(name).pipe(
      __map(_r => _r.body as Array<User>)
    );
  }

  /**
   * @param activity undefined
   */
  UserLogActivityResponse(activity?: null | string): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let __formData = new FormData();
    __body = __formData;
    if (activity != null) { __formData.append('activity', activity as unknown as string | Blob);}
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/User/LogActivity`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param activity undefined
   */
  UserLogActivity(activity?: null | string): __Observable<Blob> {
    return this.UserLogActivityResponse(activity).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param url undefined
   */
  UserWhosOnMyPageResponse(url?: null | string): __Observable<__StrictHttpResponse<Array<string>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (url != null) __params = __params.set('url', url.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/User/WhosOnMyPage`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<string>>;
      })
    );
  }
  /**
   * @param url undefined
   */
  UserWhosOnMyPage(url?: null | string): __Observable<Array<string>> {
    return this.UserWhosOnMyPageResponse(url).pipe(
      __map(_r => _r.body as Array<string>)
    );
  }
  UserWhosActiveResponse(): __Observable<__StrictHttpResponse<Array<PageUsers>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/User/WhosActive`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<PageUsers>>;
      })
    );
  }  UserWhosActive(): __Observable<Array<PageUsers>> {
    return this.UserWhosActiveResponse().pipe(
      __map(_r => _r.body as Array<PageUsers>)
    );
  }
}

module UserService {

  /**
   * Parameters for UserResetUserCache
   */
  export interface UserResetUserCacheParams {
    userId: number;
    customerId: number;
  }

  /**
   * Parameters for UserLinkProductToUser
   */
  export interface UserLinkProductToUserParams {
    userId?: number;
    productId?: number;
    description?: null | string;
  }

  /**
   * Parameters for UserUnlinkProductToUser
   */
  export interface UserUnlinkProductToUserParams {
    userId?: number;
    productId?: number;
  }
}

export { UserService }
